// extracted by mini-css-extract-plugin
export default {"date":"ConversationsGroupedByDate_date__XN-fe","root":"ConversationsGroupedByDate_root__OPJTp","hiddenDate":"ConversationsGroupedByDate_hiddenDate__G8PXw"};